import { useRecoilValue } from 'recoil';
import { kpkMediaImportsProgressSelector } from '../selectors.js';

/**
 * Get media import.
 * This hook must be called close to component to render.
 */
var useUploadElement = function (key, uuid) {
    var kpkMediaImport = useRecoilValue(kpkMediaImportsProgressSelector({ key: key, uuid: uuid }));
    return {
        kpkMediaImport: kpkMediaImport
    };
};

export { useUploadElement };
//# sourceMappingURL=useUploadElement.js.map
